var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2992 32.9025L29.2086 32.9482C28.5045 33.2534 27.6893 33.0659 27.2223 32.4912L19.2523 22.7087C18.8384 22.2012 18.1457 21.9907 17.4924 22.174L4.90761 25.7115C4.16898 25.9227 3.38942 25.628 3.00909 24.9937C2.62876 24.3595 2.74309 23.5448 3.28753 23.0098L23.4869 3.10839C23.9284 2.60954 24.6254 2.40387 25.2628 2.58432C25.9003 2.76477 26.3576 3.29716 26.4279 3.9409L30.3031 31.1566C30.4042 31.8812 29.9937 32.595 29.2992 32.9025Z",
    fill: "#282B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2614 10.6984L1.88086 20.2202",
    stroke: "#282B59",
    strokeWidth: 1.7044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2101 4.27076L3.95325 13.5296",
    stroke: "#282B59",
    strokeWidth: 1.7044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db186712d7156e1ad20f9ce85f3a6be0.svg";
export { ForwardRef as ReactComponent };